export class NutrientGraphData {
    N: number[] = [];
    P: number[] = [];
    K: number[] = [];
    Fe: number[] = [];
    Mn: number[] = [];
}
